import { Form, Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import SidebarField from "../SidebarField";
import Button, { SecondaryButton } from "../Button";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FormField } from "../FormField";
import TextInput from "../TextInput";
import ToggleField from "../ToggleField";
import Lable from "../Lable";
import Tooltip from "../Tooltip/Tooltip";
import { Divider } from "primereact/divider";
import ReactQuill from "react-quill";
import TaxData from "./TaxData";
import { ImagesData } from "./ImageData";
import { ModifierApi, productApi } from "../../App/api/ProductListing.apis";
import LoaderContext from "../loader";
import { FaRegCheckCircle } from "react-icons/fa";
import VariantData from "./VAriantData";
import { toast } from "react-toastify";
import {
  approvalStatusApi,
  multilevelApprovalApi,
} from "../../App/api/multilevelApproval.api";
import { useSelector } from "react-redux";
import { useFetchAll } from "../../custom/FetchApiHook";
import { formattedAmount } from "../../utils/helpers/Functions.helper";
import ModifierTable from "../../Pages/Dashboard/Order/FoodOrderModal/ModifierTable";
import ModifierComp from "./ModifierComp";
import ApprovalFlowManager from "../../Pages/ApproveUnapprove/ApprovalFlowManager";
import ApprovalStatus from "../../Pages/ApproveUnapprove/ApprovalStatus";

function FoodItemDetails({
  open,
  close,
  data,
  getAllProduct,
  setIsProductDetail,
  approvalStatus,
  selectedData,
}) {
  console.log("selected data :", selectedData);
  const { handleLoading } = useContext(LoaderContext);
  const [productVarient, setProductVarient] = useState(null);
  const [isModifier, setIsModifier] = useState([]);
  const [allProductVarient, setAllProductVarient] = useState(null);
  const [product, setProduct] = useState(data);

  const {
    approvalLevel,
    ApprovalFlow,
    matchedData,
    allApprovals,
    waitingForApproval,
    validateAndApprove,fetchAllData
  } = ApprovalFlowManager({
    component: "FoodProduct", 
    currentItems:selectedData,
    approvalStatus,
  });

  const product_details_info = {
    product_size: "Enter a size of product eg. 120GB, S/M/L/XL/XXL, 1 liter!",
    mrp_price: "Enter a MRP Price of product!",
    sales_price: "Enter a Sales Price of product!",
    stock: "Enter a number of stock!",
    product_width: "Enter a Width in of product in centimetre!",
    product_height: "Enter a Height of product in centimetre !",
    product_depth: "Enter a Depth of product in centimetre!",
    product_weight: "Enter a Weight of product in gram!",
  };

  const initialProductValues = {
  
    primary_image: selectedData?.primary_image || null,
    secondary_image: selectedData?.secondary_image || null,
    name: selectedData?.name || null,
    brand: selectedData?.brand || null,
    model: selectedData?.model || null,
    serial_number: selectedData?.serial_number || null,
    product_color: selectedData?.product_color || "",
    product_details:
      data === "" || selectedData?.product_details?.length === 0
        ? [
            {
              product_size: null,
              mrp_price: null,
              sales_price: null,
              stock: null,
              product_width: null,
              product_height: null,
              product_depth: 0,
              product_weight: null,
            },
          ]
        : selectedData?.product_details,
    tax: selectedData?.tax?.name || null,
    subcategory: selectedData?.subcategory?.name || null,
    additional_info: selectedData?.additional_info || null,
    description: selectedData?.description || null,
    specification: selectedData?.specification || null,
    cancellation_policy: selectedData?.cancellation_policy || null,
    replacement_policy: selectedData?.replacement_policy || null,
    return_policy: selectedData?.return_policy || null,
    is_visible: selectedData?.is_visible || true,
    sequence: selectedData?.subCategory?.sequence || null,
  };

  const getProduct = async (id) => {
    handleLoading(true);
    try {
      const res = await productApi.getFoodProductById(id);
      const modifier = await ModifierApi.getModifierById(id);
      console.log("Modifier:", modifier.data.data);
      setIsModifier(modifier.data.data);
      const product_varient = res.data?.data?.product_varient;
      setProduct(res.data.data);
      setAllProductVarient(product_varient);
    } catch (error) {
    }
    handleLoading(false);
  };
  console.log("food product:", product);

  const [step, setStep] = useState(0);
  const handleBack = async () => {
    setStep((prevStep) => Math.max(prevStep - 1, 0));
  };


  const handleNext = async (values) => {
    const payload = {
      component_id: data?._id,
      component: "FoodProduct",
      approvalFlow: allApprovals?.data?.[0]?._id,
      progress: {
        level: approvalLevel?.level,
        user: approvalLevel?.user,
        status: "Approved",
        remarks: "",
      },
    };

    if (!validateAndApprove(payload)) {
      handleLoading(false);
      return;
    }

    // console.log("values", values);
    allProductVarient?.length > 0
      ? step < 1 && setStep((prevStep) => Math.min(prevStep + 1, 2))
      : setStep(step);
    if (values === "Approve") {
      handleLoading(true);
      try {
        ApprovalFlow?.length > 0
          ? await approvalStatusApi.updateApprovalStatus(
              payload,
              ApprovalFlow?.[0]?._id
            )
          : await approvalStatusApi.createApprovalStatus(payload);

        toast.success(`Item Approved by ${approvalLevel?.level}!`);
        setStep((prev) => 0);
        getAllProduct();
        setIsProductDetail(false);
        handleLoading(false);
      } catch (error) {
        // console.log(error);
        handleLoading(false);
      }
    }
  };

  const handleClose = () => {
    setAllProductVarient(null);
    setProductVarient(null);
    setProduct(null);
    close();
  };
  useEffect(() => {
    if (data?._id) {
      getProduct(data?._id);
      fetchAllData();
    }
  }, [data]);

  if (open) {
    return (
      <>
        {open && (
          <Formik
            enableReinitialize={true}
            initialValues={initialProductValues}
            onSubmit={() => {}}
          >
            {({ handleChange, setFieldValue, values }) => (
              <SidebarField
                button1={
                  step === 0 ? (
                    ""
                  ) : (
                    <Button text="Back" type="button" onClick={handleBack} />
                  )
                }
                button2={
                  <Button
                    disable={
                      ApprovalFlow?.[0]?.progress?.status === "Approved"
                        ? "disabled"
                        : ""
                    }
                    text={
                      ApprovalFlow?.[0]?.progress?.status === "Approved"
                        ? "Approved"
                        : allProductVarient?.length > 0 && step === 0
                        ? "Next "
                        : "Approve"
                    }
                    type="submit"
                    onClick={
                      allProductVarient?.length > 0 && step === 0
                        ? () => handleNext("Next")
                        : () => handleNext("Approve")
                    }
                  />
                }
                handleClose={() => handleClose()}
                title={step === 0 ? "Product Details" : "Variant Details"}
              >
                <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
                  {step === 0 && (
                    <>
                      <div className="flex items-center justify-center">
                        <label
                          htmlFor="primary_image"
                          className="w-60 h-60 shadow-lg border border-gray-200 rounded-xl flex flex-col items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-xl hover:border-blue-400"
                        >
                          {data?._id &&
                          typeof values.primary_image !== "object" ? (
                            <LazyLoadImage
                              src={values.primary_image}
                              alt="Uploaded"
                              loading="lazy"
                              effect="blur"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              className="rounded-xl"
                            />
                          ) : (
                            ""
                          )}
                        </label>
                      </div>
                      <ImagesData imagesData={values.secondary_image} />
                      <FormField
                        label="Sub Category"
                        tooltip="This is sub category of Food Item"
                      >
                        <div id="subcategory">
                          <TextInput
                            placeholder={values?.subcategory?.name}
                            value={values?.subcategory?.name}
                            disabled={true}
                          />
                        </div>
                      </FormField>
                      <FormField label="Food Name" tooltip="This is Food Name">
                        <div className="flex items-center" id="item_name">
                          <span className="border p-2 pl-3 pr-5 text-sm border-r-none">
                            EN
                          </span>
                          <TextInput
                            type="text"
                            value={values.name}
                            disabled={true}
                          />
                        </div>
                      </FormField>
                      <FormField
                        label="Food Price"
                        tooltip="This is Food Price"
                      >
                        <TextInput
                          type="text"
                          value={formattedAmount(values.price)}
                          disabled={true}
                        />
                      </FormField>
                      {/* <FormField label="Brand Name" tooltip="Enter brand name">
                        <div className="flex items-center">
                          <span className="border p-2 pl-3 pr-5 text-sm border-r-none">
                            EN
                          </span>
                          <TextInput
                            value={values.brand}
                            placeholder="Item brand"
                            type="text"
                            disabled={true}
                          />
                        </div>
                      </FormField>
                      <FormField label="Model" tooltip="Enter model name">
                        <div className="flex items-center">
                          <span className="border p-2 pl-3 pr-5 text-sm border-r-none">
                            EN
                          </span>
                          <TextInput
                            name="model"
                            type="text"
                            placeholder="Item model"
                            value={values.model}
                            disabled={true}
                          />
                        </div>
                      </FormField> */}
                      {/* <div id="is_color">
                        <ToggleField
                          text="Color?"
                          name="is_color"
                          value={values.product_color}
                          disabled={true}
                        />
                      </div>
                      {values.product_color ? (
                        <FormField
                          label="Product color"
                          tooltip="Pick Product Color"
                        >
                          <div
                            className="flex items-center  relative"
                            id="product_color"
                          >
                            <label
                              style={{ background: values.product_color }}
                              htmlFor="product_color"
                              className={`overflow-hidden  border-2 border-gray-950  w-full h-[2rem] inline-block`}
                            >
                              <input
                                id="product_color"
                                name="product_color"
                                type="color"
                                placeholder="color"
                                value={values.product_color}
                                // onChange={handleChange}
                                required={false}
                                style={{
                                  width: "100%",
                                  height: "6rem",
                                  marginTop: "-2rem",
                                  border: "none",
                                  outline: "none",
                                  borderRadius: "100%",
                                  background: "transparent",
                                }}
                                disabled={true}
                              />
                            </label>
                          </div>
                        </FormField>
                      ) : (
                        ""
                      )} */}
                      <FormField
                        label="TAX"
                        className="w-[100%]"
                        tooltip="Selected type of Tex"
                      >
                        <TextInput value={values.tax} disabled={true} />
                      </FormField>
                      {/* <div className="flex items-center justify-between mb-2">
                        <span className="flex">
                          <Lable lable={"Product Details"} />
                          <Tooltip text={"Add more details of Product"} />
                        </span>
                      </div> */}

                      {/* <div id="product_details" className=" w-full">
                        {values.product_details?.map((item, i) => (
                          <>
                            {Object.keys(item).map((label, index) => (
                              <div
                                id={`${label}_${i}`}
                                key={`${i}${index}`}
                                className={`border ${
                                  label === "product_size" ||
                                  label === "mrp_price" ||
                                  label === "sales_price" ||
                                  label === "stock" ||
                                  label === "product_width" ||
                                  label === "product_width" ||
                                  label === "product_height" ||
                                  label === "product_weight" ||
                                  label === "product_depth"
                                    ? "flex"
                                    : "hidden"
                                }  justify-between mb-1 items-center text-[12px]`}
                              >
                                <span className="w-[50%] border-r px-2 py-2  gap-2 capitalize  flex justify-between items-center">
                                  <label className="text-[.85rem]">
                                    {label.replace("_", " ")}
                                  </label>{" "}
                                  <Tooltip text={product_details_info[label]} />
                                </span>
                                <TextInput
                                  name={`${label}`}
                                  type={
                                    label === "product_size" ? "text" : "number"
                                  }
                                  placeholder={`${label.replace("_", " ")}`}
                                  disabled={true}
                                  value={
                                    label === "mrp_price" ||
                                    label === "sales_price"
                                      ? values.product_details[i][`${label}`]
                                          ?.$numberDecimal
                                        ? values.product_details[i][`${label}`]
                                            ?.$numberDecimal
                                        : values.product_details[i][`${label}`]
                                      : values.product_details[i][`${label}`]
                                  }
                                  required={
                                    label === "product_size" ||
                                    label === "product_depth"
                                      ? false
                                      : true
                                  }
                                  className={`capitalize`}
                                />
                              </div>
                            ))}
                            <Divider className="border border-gray-300" />
                            <div>
                              <h1>Tax Details</h1>
                               {JSON.stringify(productDetailsWithTax)} 
                              <TaxData key={i} item={item} />
                            </div>

                             <TaxView Taxes={Taxes} deliveryFee={deliveryType} item={item?.sales_price?.$numberDecimal?{sales_price:item?.sales_price?.$numberDecimal}:item}/>
                            <Divider className="border border-gray-300" />
                          </>
                        ))}
                      </div> */}

                      <FormField
                        label="Description"
                        tooltip="description of Food"
                      >
                        <div id="description">
                          <ReactQuill
                            theme="snow"
                            value={values.description}
                            // onChange={(v) => setFieldValue("description", v)}
                            readOnly={true}
                          />
                        </div>
                      </FormField>

                      {/* <FormField
                        label="Additional Information"
                        tooltip="write a brief additional information of item"
                      >
                        <div id="additional_info">
                          <ReactQuill
                            theme="snow"
                            value={values.additional_info}
                            readOnly={true}
                            // onChange={(v) => setFieldValue("additional_info", v)}
                          />
                        </div>
                      </FormField> */}

                      {/* <FormField
                        label="Specifications"
                        tooltip="write a brief Specifications of item"
                      >
                        <div id="specification">
                          <ReactQuill
                            theme="snow"
                            value={values.specification}
                            readOnly={true}
                            // onChange={(v) => setFieldValue("specification", v)}
                          />
                        </div>
                      </FormField> */}

                      <FormField
                        label="Cancellation policy"
                        tooltip=" policy of Food item"
                      >
                        <div id="cancellation_policy">
                          <ReactQuill
                            theme="snow"
                            value={values.cancellation_policy}
                            readOnly={true}
                            // onChange={(v) =>
                            //   setFieldValue("cancellation_policy", v)
                            // }
                          />
                        </div>
                      </FormField>
                      {/* <FormField
                        label="Replacement policy"
                        tooltip="write a brief replacement policy of item"
                      >
                        <div id="replacement_policy">
                          <ReactQuill
                            theme="snow"
                            value={values.replacement_policy}
                            readOnly={true}
                            // onChange={(v) =>
                            //   setFieldValue("replacement_policy", v)
                            // }
                          />
                        </div>
                      </FormField> */}

                      <FormField
                        label="Return policy"
                        tooltip="Return policy of Food item"
                      >
                        <div id="return_policy">
                          <ReactQuill
                            theme="snow"
                            value={values.return_policy}
                            readOnly={true}
                            // onChange={(v) => setFieldValue("return_policy", v)}
                          />
                        </div>
                      </FormField>

                      <div className="flex justify-between flex-wrap-reverse gap-4">
                        <div id="is_visible">
                          <ToggleField
                            text="Is Item Visible to user?"
                            name="is_visible"
                            value={values.is_visible}
                            disabled={true}
                          />
                        </div>

                        {/* <FormField
                          label="Sequence Number"
                          tooltip="Enter sequence Number"
                        >
                          <div id="sequence">
                            <TextInput
                              name="sequence"
                              type="number"
                              value={values.sequence}
                              disabled={true}
                              // onChange={handleChange}
                            />
                          </div>
                        </FormField> */}
                      </div>
                      <div className="">
                        {isModifier ? (
                          <ModifierComp data={isModifier} />
                        ) : (
                          "customization Not Available"
                        )}
                      </div>
                    </>
                  )}
                  <VariantData
                    open={Boolean(productVarient)}
                    data={productVarient}
                    close={() => setProductVarient(null)}
                  />
                  {step === 1 && allProductVarient && allProductVarient?.length
                    ? allProductVarient?.map((p, i) => (
                        <div
                          key={p._id}
                          className="w-full h-fit p-3 shadow-2xl rounded-lg flex flex-col gap-4"
                        >
                          <div className="flex justify-between items-center">
                            <div className="flex gap-1.5 items-center ">
                              <FaRegCheckCircle className="text-lg text-hoverColor" />
                              <span className="text-[17px]">
                                {i + 1}. {p?.name}
                              </span>
                            </div>
                            <div className="flex gap-2">
                              <SecondaryButton
                                onClick={() => {
                                  // setIsVariant(true);
                                  setProductVarient(p);
                                }}
                                text="View"
                              />
                            </div>
                          </div>
                        </div>
                      ))
                    : ""}
                </Form>
                <ApprovalStatus
                  matchedData={matchedData}
                  waitingForApproval={waitingForApproval}
                />
              </SidebarField>
            )}
          </Formik>
        )}
      </>
    );
  }
}

export default FoodItemDetails;
